export default __webpack_public_path__ + "static/media/(100).168b7e1c.jpg";